/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_DescriptionInputs */

const zh_chat_description = /** @type {(inputs: Chat_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`StudyOS 智能对话`)
};

const en_chat_description = /** @type {(inputs: Chat_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`StudyOS Smart Conversation`)
};

const es_chat_description = /** @type {(inputs: Chat_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversación inteligente StudyOS`)
};

/**
* | output |
* | --- |
* | "StudyOS Smart Conversation" |
*
* @param {Chat_DescriptionInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const chat_description = /** @type {((inputs?: Chat_DescriptionInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_DescriptionInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_chat_description(inputs)
	if (locale === "en") return en_chat_description(inputs)
	return es_chat_description(inputs)
});